export default "__VITE_ASSET__BbAzKgBw__"